import '../App.css';
import React, { useEffect } from 'react';
import { auth } from '../firebase';
import { useState } from 'react';
import { signInAnonymously } from "firebase/auth";
import { logDemographics, logNewUser, logPostHighlightSurvey } from '../logging.js';
import { TextField, Flex, Button, Form, Provider, defaultTheme, Text, Heading, Radio, RadioGroup, ContextualHelp, Content, CheckboxGroup, Checkbox, TextArea, Slider } from '@adobe/react-spectrum';

function PostHighlightForm({participantId, maxWordCount, specificExample, callbacks}) {
    // Results
    const [mentalDemand, setMentalDemand] = useState(0);
    const [physicalDemand, setPhysicalDemand] = useState(0);
    const [temporalDemand, setTemporalDemand] = useState(0);
    const [performance, setPerformance] = useState(0);
    const [effort, setEffort] = useState(0);
    const [frustration, setFrustration] = useState(0);
    
    const [experience, setExperience] = useState('');
    const [additionalComments, setAdditionalComments] = useState('');

    // Validation
    const [formValidated, setFormValidated] = useState(false);

    useEffect(() => {
        validateForm();
    }, [mentalDemand, physicalDemand, temporalDemand, performance, effort, frustration, experience, additionalComments]);

    function validateForm() {
        if (mentalDemand > 0 && physicalDemand > 0 && temporalDemand > 0 && performance > 0 && effort > 0 && frustration > 0 && experience !== '') {
            setFormValidated(true);
        }

        else {
            setFormValidated(false);
        }
    }

    function submitForm(e) {
        e.preventDefault();
        var results = {
            mentalDemand: mentalDemand,
            physicalDemand: physicalDemand,
            temporalDemand: temporalDemand,
            performance: performance,
            effort: effort,
            frustration: frustration,
            experience: experience,
            additionalComments: additionalComments,
            participantId: participantId
        }

        logPostHighlightSurvey(results, callbacks);
    }

    return (
        <>    
            <Provider theme={defaultTheme} colorScheme='light'>
                <Flex direction="column" justifyContent={'center'} alignItems={"center"}>             
                    <div id="textToRead" className='documentReader'>
                        <Heading level={1} width="100%" marginBottom="size-100" marginTop="size-0">Post-Highlighting Questions</Heading>
                        <Text>Please answer the following questions about your experience highlighting the document using the provided document reader. <b>All questions are mandatory unless indicated otherwise.</b></Text>
                        <Form onSubmit={e => submitForm(e)}>    
                            
                            {/* Mental Demand */}
                            <RadioGroup marginBottom="size-100" onChange={setMentalDemand} orientation='horizontal'  label={<Heading level={3} width="100%" marginBottom="size-100" marginTop="size-0">How mentally demanding was the task?</Heading>}>                     
                                <Text marginEnd={"size-500"} marginTop={"size-50"}>Very low</Text>
                                {[...Array(7)].map((e, i) => <Radio  value={(i+1)}>{(i+1)}</Radio>)}
                                <Text marginStart={"size-500"} marginTop={"size-50"}>Very high</Text>
                            </RadioGroup>  
                            
                            {/* Physical Demand */}
                            <RadioGroup marginBottom="size-100" onChange={setPhysicalDemand} orientation='horizontal'  label={<Heading level={3} width="100%" marginBottom="size-100" marginTop="size-0">How physically demanding was the task?</Heading>}>                     
                                <Text marginEnd={"size-500"} marginTop={"size-50"}>Very low</Text>
                                {[...Array(7)].map((e, i) => <Radio  value={(i+1)}>{(i+1)}</Radio>)}
                                <Text marginStart={"size-500"} marginTop={"size-50"}>Very high</Text>
                            </RadioGroup>  

                            {/* Temporal Demand */}
                            <RadioGroup marginBottom="size-100" onChange={setTemporalDemand} orientation='horizontal'  label={<Heading level={3} width="100%" marginBottom="size-100" marginTop="size-0">How hurried or rushed was the pace of the task?</Heading>}>                     
                                <Text marginEnd={"size-500"} marginTop={"size-50"}>Very low</Text>
                                {[...Array(7)].map((e, i) => <Radio  value={(i+1)}>{(i+1)}</Radio>)}
                                <Text marginStart={"size-500"} marginTop={"size-50"}>Very high</Text>
                            </RadioGroup>  
                            
                            {/* Performance */}
                            <RadioGroup marginBottom="size-100" onChange={setPerformance} orientation='horizontal'  label={<Heading level={3} width="100%" marginBottom="size-100" marginTop="size-0">How successful were you in accomplishing what you were asked to do?</Heading>}>                     
                                <Text marginEnd={"size-600"} marginTop={"size-50"}>Failure</Text>
                                <Text marginEnd={"size-50"}></Text>
                                {[...Array(7)].map((e, i) => <Radio  value={(i+1)}>{(i+1)}</Radio>)}
                                <Text marginStart={"size-500"} marginTop={"size-50"}>Perfect</Text>
                            </RadioGroup>  

                            {/* Effort */}
                            <RadioGroup marginBottom="size-100" onChange={setEffort} orientation='horizontal'  label={<Heading level={3} width="100%" marginBottom="size-100" marginTop="size-0">How hard did you have to work to read {maxWordCount === 0 ? null : " and highlight"} the passage?</Heading>}>                     
                                <Text marginEnd={"size-500"} marginTop={"size-50"}>Very low</Text>
                                {[...Array(7)].map((e, i) => <Radio  value={(i+1)}>{(i+1)}</Radio>)}
                                <Text marginStart={"size-500"} marginTop={"size-50"}>Very high</Text>
                            </RadioGroup>  

                            {/* Frustration */}
                            <RadioGroup marginBottom="size-100" onChange={setFrustration} orientation='horizontal'  label={<Heading level={3} width="100%" marginBottom="size-100" marginTop="size-0">How insecure, discouraged, irriated, stressed, and annoyed were you?</Heading>}>                     
                                <Text marginEnd={"size-500"} marginTop={"size-50"}>Very low</Text>
                                {[...Array(7)].map((e, i) => <Radio  value={(i+1)}>{(i+1)}</Radio>)}
                                <Text marginStart={"size-500"} marginTop={"size-50"}>Very high</Text>
                            </RadioGroup>

                            {/* Experience */}
                            <TextArea marginBottom="size-100" onChange={setExperience} label={<Heading level={3} width="100%" marginBottom="size-100" marginTop="size-0">Focusing on 2 or 3 points, what was your experience like using the provided document viewer? {specificExample}</Heading>} />                 


                            {/* Additional Comments */}
                            <TextArea marginBottom="size-100" onChange={setAdditionalComments} label={<Heading level={3} width="100%" marginBottom="size-100" marginTop="size-0">Do you have any additional comments about your experience using the document viewer? (optional)</Heading>} />                 
  
                            <Button variant='primary' type="submit" style='fill' marginTop="size-600" isDisabled={!formValidated}>Submit</Button>
                        </Form>
                    </div>
                </Flex>
            </Provider>
        </>
    );
}

export default PostHighlightForm;